import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { AdjustPlayerBalanceDTO, PlayerBalanceDTO } from './manual-adjustment.model';

@Injectable({
  providedIn: 'root',
})
export class ManualAdjustmentService {
  constructor(private http: HttpClient) {}

  getBalancesForPlayer(playerId: number): Observable<PlayerBalanceDTO> {
    return this.http.get<PlayerBalanceDTO>(`/player/${playerId}/balance`);
  }

  adjustForPlayer(playerId: number, rq: AdjustPlayerBalanceDTO): Observable<PlayerBalanceDTO> {
    return this.http.post<PlayerBalanceDTO>(`/player/${playerId}/balance`, rq);
  }
}
